import { addDoc, collection, getDocs, limit, orderBy, query, where } from "firebase/firestore";
import { db } from "../apis/auth";

export async function getSystemUpTimeData(collectionName, count = 10, startTimestamp = null, endTimestamp = null, getLastRecordOnly = false) {
    try {
        // For getting just the last record (used in fetchAvailableYears)
        if (getLastRecordOnly) {
            const currentYear = new Date().getFullYear();

            // Create a date object for Dec 31st, 23:59:59.999 of the current year
            const endOfCurrentYear = new Date(currentYear, 11, 31, 23, 59, 59, 999);

            const queryObj = query(
                collection(db(), collectionName),
                where("dt", "<=", endOfCurrentYear),
                orderBy("dt", "asc"),
                limit(1)
            );

            const querySnapshot = await getDocs(queryObj);
            return querySnapshot.docs.map(doc => {
                console.log(doc.data())
                return (doc.data())
            });
        }


        // For yearly data (date range provided)
        if (startTimestamp && endTimestamp) {
            const queryObj = query(
                collection(db(), collectionName),
                where("dt", ">=", new Date(startTimestamp * 1000)),
                where("dt", "<=", new Date(endTimestamp * 1000)),
                orderBy("dt", "asc")
            );

            const querySnapshot = await getDocs(queryObj);
            return querySnapshot.docs.map(doc => doc.data());
        }

        // Create endDate as end of yesterday
        const endDate = new Date();
        endDate.setDate(endDate.getDate() - 1); // move to yesterday
        endDate.setHours(23, 59, 59, 999);

        // Create startDate as end of (count) days ago
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - (count - 1)); // count days ending at yesterday
        startDate.setHours(0, 0, 0, 0);

        const queryObj = query(
            collection(db(), collectionName),
            where("dt", ">=", startDate),
            where("dt", "<=", endDate),
            orderBy("dt", "desc"),
            limit(count)
        );


        const querySnapshot = await getDocs(queryObj);
        return querySnapshot.docs.map(doc => doc.data());

    } catch (error) {
        console.error(`Error in getSystemUpTimeData for ${collectionName}:`, error);
        return [];
    }
}